import * as Types from 'types/types';

export type SortField = 'updatedAt' | 'createdAt' | 'company' | 'title';
export type SortOrder = 'asc' | 'desc';

export function formatPayRange(min?: string | number | null, max?: string | number | null): string {
  return `${min ?? 'N/A'}-${max ?? 'N/A'}`;
}

export function jobSummaryText(job: Types.Job): string {
  return job.summary || job.description || '';
}

function getSortValue(job: Types.Job, field: SortField): number | string {
  switch (field) {
    case 'updatedAt':
      return job.updatedAt?.getTime() ?? 0;
    case 'createdAt':
      return job.createdAt?.getTime() ?? 0;
    case 'company':
      return job.company?.toLowerCase() ?? '';
    case 'title':
      return job.title?.toLowerCase() ?? '';
    default:
      return 0;
  }
}

export function sortJobs(jobsList: Types.Job[], field: SortField, order: SortOrder): Types.Job[] {
  return [...jobsList].sort((a, b) => {
    const aValue = getSortValue(a, field);
    const bValue = getSortValue(b, field);
    if (aValue < bValue) return order === 'asc' ? -1 : 1;
    if (aValue > bValue) return order === 'asc' ? 1 : -1;
    return 0;
  });
}

export function getOwnerName(owner?: Types.BaseUser): string {
  if (!owner) return 'Unknown';
  return `${owner.firstName || ''} ${owner.lastName || ''}`.trim() || owner.email || 'Unknown';
}

export function truncateDescription(description: string, maxLength = 100): string {
  if (description.length <= maxLength) return description;
  return description.substring(0, maxLength) + '...';
}

export function formatJobDate(date: Date | undefined, isMobile: boolean, isSmall: boolean): string {
  if (!date) return 'N/A';
  return new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    ...(isMobile ? {} : { year: 'numeric' }),
    ...(isSmall ? {} : { hour: '2-digit', minute: '2-digit' }),
  }).format(date);
}
